import { cx } from '@linaria/core';
import { MouseEvent, ReactNode } from 'react';
import Popover, { PopoverOrigin } from './Popover';
import "./Menu.linaria.module.css!=!./Menu?./Menu.linaria.module.css?css=H4sIAAAAAAAAA13P3QqDMAwF4HvfY5eKG15IfZhSsY1h6Q8a0VJ897GxldXLQ75DkkaxlRjlfe834i1ZddSzRphZ9O1tOKvmDQAlTsFAl6xaAJ1ofxPy0jAgPcqUgpomdFCzD6IPR+a64PrKR8/sbdF4fleXKTdIG/47hwpNV718PsscRgkUd2MT4cr1ypG0cN7p4axeB3irrRoBAAA="
const paperStyles = "atm_iy_1w8ultu";
const listStyles = "atm_gi_idpfg4 atm_lo_ftgil2 atm_le_ftgil2 atm_lk_idpfg4 atm_ll_idpfg4 atm_gb_glywfm";
export interface MenuProps {
  anchorEl: HTMLElement | null;
  anchorOrigin?: PopoverOrigin;
  'aria-labelledby'?: string;
  children: ReactNode;
  /** lands on the paper, so it can size and scroll the list */
  className?: string;
  'data-testid'?: string;
  fitBelowAnchor?: boolean;
  id?: string;
  matchAnchorWidth?: boolean;
  onClose?(): void;
  open: boolean;
  role?: 'menu' | 'listbox';
  transformOrigin?: PopoverOrigin;
  zIndex?: number;
}
const Menu = (props: MenuProps) => {
  const {
    children,
    className,
    onClose,
    role = 'menu',
    'aria-labelledby': ariaLabelledBy,
    ...popoverProps
  } = props;

  // picking a row closes the menu; the list's own padding doesn't
  const onListClick = (event: MouseEvent<HTMLUListElement>) => {
    if ((event.target as Element).closest('li')) onClose?.();
  };
  return <Popover {...popoverProps} className={cx('mfc-menu', paperStyles, className)} onClose={onClose}>
            <ul aria-labelledby={ariaLabelledBy} className={cx('menu-list', listStyles)} onClick={onListClick} role={role}>
                {children}
            </ul>
        </Popover>;
};
export default Menu;